module.exports = __webpack_public_path__ + "387985c41a8f96968043a6bfb84d7e91.png";